// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SeF7","label":"styles_label__1oi5Q"};